import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import useNetworkHandler from "../hooks/networkHandler";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SessionPopupWrapper = ({ children }) => {
  const navigate = useNavigate();

  const [
    session,
    setSession,
    networkError,
    setNetworkError,
    alertToast,
    setAlertToast,
    errMsg,
  ] = useNetworkHandler();
  const [open_popup, setOpen_popup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const [open, setOpen] = React.useState(false);
 
  const handleClick = () => {
    setOpen(true);
  };

  useMemo(() => {
    setOpen(alertToast);
  }, [alertToast]);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
 

  const handle_pop_up_close = () => {
    setOpen_popup(false);
    goto_login();
    setSession(false);
  };
  const handleError_popup_close = () => {
    setErrorPopup(false);
    setNetworkError(false);
    // navigate({ pathname: "/login" });
  };

  const goto_login = () => {
    navigate({ pathname: "/login" });
  };

  useEffect(() => {
    setOpen_popup(session);
    setErrorPopup(networkError); 
  }, [session, networkError]);

  return (
    <>
      <Dialog
        open={open_popup}
        onClose={handle_pop_up_close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            backgroundColor: "#f07821",
            color: "#ffffff",
            textAlign: "center",
            // fontFamily: "poppins",
          }}
        >
          Access Denied!
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{
              marginTop: "1rem",
              //   fontFamily: "poppins",
              width: "235px",
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            <h2>Session is Expired!</h2>
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{ justifyContent: "center", marginBottom: "1rem" }}
        >
          {/* <Button variant="contained" style={{backgroundColor: '#ffffff', color: '#094A77', width: '40%', fontFamily: 'poppins'}} onClick={handle_pop_up_close}>Login</Button> */}

          <Button
            variant="contained"
            style={{
              backgroundColor: "#f07821",
              color: "#ffffff",
              width: "40%",
              //   fontFamily: "poppins",
            }}
            onClick={handle_pop_up_close}
            autoFocus
          >
            Login
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={errorPopup}
        onClose={handleError_popup_close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            backgroundColor: "#f07821",
            color: "#ffffff",
            textAlign: "center",
            // fontFamily: "poppins",
          }}
        >
          Error
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ marginTop: "1rem" }}
          >
            <h3>Something went wrong!</h3>
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{ justifyContent: "center", marginBottom: "1rem" }}
        >
          {/* <Button variant="contained" style={{backgroundColor: '#ffffff', color: '#094A77', width: '40%', fontFamily: 'poppins'}} onClick={handle_pop_up_close}>Login</Button> */}

          <Button
            variant="contained"
            style={{
              backgroundColor: "var(--brandColor)",
              color: "#ffffff",
              width: "40%",
              //   fontFamily: "poppins",
            }}
            onClick={handleError_popup_close}
            autoFocus
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={alertToast}
        autoHideDuration={3000}
        onClose={() => setAlertToast((prev) => !prev)}
      >
        <Alert
          onClose={() => setAlertToast((prev) => !prev)}
          severity="error"
          sx={{ width: "100%", backgroundColor: "white", color: "black", }}
        >
          {errMsg}
        </Alert>
      </Snackbar>

      <div>{children}</div>
    </>
  );
};

export default SessionPopupWrapper;
